import { GlobalNavigationItem, styled } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { ECounterType } from "@tm/models"
import { TmaHelper } from "@tm/utils"
import { useUserSettingsStore } from "../user-settings/business"

const GlobalNavigationUserSettings = styled(GlobalNavigationItem)(({ theme }) => ({
    "&.global-navigation-flat": {
        marginRight: "1.5rem",
        borderRight: `1px solid ${theme.palette.grey.A400}60`,
        "&.active": {
            background: `${theme.palette.grey[100]}`,
        },
    },
}))

function UserSettingsButton() {
    const { translateText } = useLocalization()

    const { openUserSettingsDialog, toggleUserSettingsDialog } = useUserSettingsStore((userSettingsStore) => ({
        openUserSettingsDialog: userSettingsStore.state.openUserSettings,
        toggleUserSettingsDialog: userSettingsStore.actions.setOpenOrToggleUserSettings,
    }))

    const handleClick = () => {
        !openUserSettingsDialog && TmaHelper.GeneralCountEvent.Call(ECounterType.SettingsOpen)
        toggleUserSettingsDialog()
    }

    return (
        <GlobalNavigationUserSettings
            active={openUserSettingsDialog}
            name="user-settings"
            componentType="icon"
            className="user-settings"
            onIconClick={handleClick}
            tooltip={translateText(141)}
        />
    )
}

export default UserSettingsButton
